"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 13.2",
    width: "34",
    height: "13.2"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M30.6,8.9h-28c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h28c0.3,0,0.5,0.2,0.5,0.5S30.9,8.9,30.6,8.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M33.5,8.9h-3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5S33.8,8.9,33.5,8.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M3.5,8.9h-3C0.2,8.9,0,8.7,0,8.4s0.2-0.5,0.5-0.5h3C3.8,7.9,4,8.1,4,8.4S3.8,8.9,3.5,8.9z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.5",
    y: "8.6",
    fill: "#9ECE06",
    width: "10.7",
    height: "1.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M22.2,10.7H11.5c-0.3,0-0.5-0.2-0.5-0.5V8.6c0-0.3,0.2-0.5,0.5-0.5h10.7c0.3,0,0.5,0.2,0.5,0.5v1.6 C22.7,10.5,22.5,10.7,22.2,10.7z M12,9.7h9.7V9.1H12V9.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M8.1,13.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S9.5,13.2,8.1,13.2z M8.1,9.2 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S9,9.2,8.1,9.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M3.7,13.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S5.1,13.2,3.7,13.2z M3.7,9.2 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.5,9.2,3.7,9.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M29.9,13.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S31.3,13.2,29.9,13.2z M29.9,9.2 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S30.8,9.2,29.9,9.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M25.5,13.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5S28,9.4,28,10.7S26.9,13.2,25.5,13.2z M25.5,9.2 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S26.3,9.2,25.5,9.2z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "17.1",
    cy: "3.4",
    r: "3.4"
  }));
};

exports["default"] = _default;